if (!customElements.get('filter-container')) {
  customElements.define(
    'filter-container',
    class FilterContainer extends HTMLElement {
      #articles = JSON.parse(
        document.querySelector('[data-recipe-articles]').textContent
      )
      #metafields = JSON.parse(
        document.querySelector('[data-recipe-metafields]').textContent
      )
      #currentFilters = {
        seafoodTypeResults: [],
        seafoodTypeValue: null,
        cookingMethodResults: [],
        cookingMethodValue: null,
        occasionResults: [],
        occasionValues: null
      }
      #currentMatches = []

      #resultCount = 0
      #resultPages = []

      #pageSize = 12
      #startIndex = 0
      #endIndex = this.#pageSize - 1
      #selectedPage = 1

      connectedCallback() {
        this.addEventListener('click', this.clickHandler.bind(this))
        this.initPaginator()
      }

      resetPaginatorValues(array) {
        let pageSize = this.#pageSize
        let pageCount = array.length / pageSize
        const pageCountRemainder = pageCount % 1
        const pageCountWithoutRemainder = Math.floor(pageCount)

        if (pageCountRemainder > 0) {
          pageCount = Number(pageCountWithoutRemainder) + 1
        }

        this.#resultPages = Array(pageCount)
          .fill(1)
          .map((x, i) => i + 1)

        document.querySelector('.paginator .pages-total').innerHTML =
          this.#resultPages.at(-1)

        this.#startIndex = 0
        this.#endIndex = pageSize - 1
        this.#selectedPage = 1
        document.querySelector('.paginator input[type=number]').value =
          this.#selectedPage
      }

      initPaginator() {
        this.resetPaginatorValues(this.#articles)
        this.displayPage()

        document.querySelectorAll('.paginator button').forEach((button) => {
          button.addEventListener('click', (e) => {
            const { target } = e
            if (target.closest('button').classList.contains('prev-page')) {
              this.goPrevious()
            } else {
              this.goNext()
            }

            console.debug({
              startIndex: this.#startIndex,
              endIndex: this.#endIndex,
              selectedPage: this.#selectedPage
            })

            document.querySelector('.paginator input[type=number]').value =
              this.#selectedPage

            this.displayPage()
          })
        })

        document
          .querySelector('.paginator input[type=number]')
          .addEventListener('change', (e) => {
            this.goToPage(parseInt(e.target.closest('input').value))
          })
      }

      goPrevious = () => {
        if (this.#selectedPage != 1) {
          this.#startIndex -= this.#pageSize
          this.#endIndex -= this.#pageSize
          this.#selectedPage--
        }
      }

      goNext = () => {
        if (this.#selectedPage < this.#resultPages.length) {
          this.#startIndex += this.#pageSize
          this.#endIndex += this.#pageSize
          this.#selectedPage++
        }
      }
      goToPage = (page) => {
        if (page < this.#resultPages.length) {
          this.#selectedPage = page

          if (page > 1) {
            this.#startIndex = this.#pageSize * page - 1
            this.#endIndex = this.#startIndex + this.#pageSize - 1
          } else {
            this.#startIndex = 0
            this.#endIndex = this.#pageSize - 1
          }
          console.debug({
            start: this.#startIndex,
            end: this.#endIndex
          })
          this.displayPage()
        }
      }

      displayPage() {
        const { seafoodTypeValue, cookingMethodValue, occasionValues } =
          this.#currentFilters

        if (!seafoodTypeValue && !cookingMethodValue && !occasionValues) {
          this.clearFilters()
          this.resetHiddenCards()

          // hide all cards except the ones with index match
          document
            .querySelectorAll('.article-card-wrapper')
            .forEach((card, index) => {
              if (index < this.#startIndex || index > this.#endIndex) {
                card.closest('.article').classList.add('hidden')
              }
            })
        } else {
          document.querySelectorAll('.article-card-wrapper').forEach((card) => {
            card.closest('.article').classList.add('hidden')
          })

          // console.debug({ currentMatches: this.#currentMatches })

          this.#currentMatches.forEach((match, index) => {
            if (index >= this.#startIndex && index <= this.#endIndex) {
              if (
                document.querySelector(
                  `.article-card-wrapper[data-article-id="${match}"]`
                )
              ) {
                document
                  .querySelector(
                    `.article-card-wrapper[data-article-id="${match}"]`
                  )
                  .closest('.article')
                  .classList.remove('hidden')
              }
            }
          })
        }

        this.scrollToGridTop()
      }

      scrollToGridTop() {
        const elementPosition = document
          .querySelector('.blog-content-container')
          .getBoundingClientRect().top
        const offsetPosition =
          elementPosition +
          window.pageYOffset -
          document
            .getElementById('shopify-section-header')
            .getBoundingClientRect().height

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        })
      }

      clickHandler(e) {
        // open / close filter drawer in mobile
        if (
          e.target.closest('.filter-header .heading') ||
          e.target.closest('.article-count')
        ) {
          if (window.innerWidth < 769) {
            this.toggleDrawer()
            setTimeout(() => {
              this.querySelectorAll('details').forEach((details, i) => {
                if (e.target.closest('.main-container.filter-drawer-open')) {
                  if (i === 0) {
                    details.setAttribute('open', true)
                  } else {
                    details.removeAttribute('open')
                  }
                } else {
                  details.setAttribute('open', true)
                }
              })
            })
          }
        }

        // clear filter facet on mobile
        if (e.target.closest('.filter-facet-pill')) {
          if (e.target.closest('fieldset[data-filter="seafood-type"]')) {
            // go to next tick, otherwise it interferes with the label click
            setTimeout(() => {
              this.clearFilters()
            })
          }
          if (e.target.closest('fieldset[data-filter="cooking-method"]')) {
            setTimeout(() => {
              this.#currentFilters.cookingMethodResults = []
              this.querySelectorAll(
                `[data-filter="cooking-method"] input`
              ).forEach((input) => {
                input.checked = false
              })
              this.#currentFilters.occasionResults = []
              this.querySelectorAll(`[data-filter="occasion"] input`).forEach(
                (input) => {
                  input.checked = false
                }
              )

              this.resetHiddenCards()
              if (this.#currentFilters.seafoodTypeValue) {
                this.updateView(
                  this.#currentFilters.seafoodTypeValue,
                  'seafood-type'
                )
              } else {
                this.clearFilters()
              }
            })
          }
          if (e.target.closest('fieldset[data-filter="occasion"]')) {
            setTimeout(() => {
              this.#currentFilters.occasionResults = []
              this.querySelectorAll(`[data-filter="occasion"] input`).forEach(
                (input) => {
                  input.checked = false
                }
              )

              this.resetHiddenCards()
              if (
                this.#currentFilters.seafoodTypeValue &&
                this.#currentFilters.cookingMethodValue
              ) {
                this.updateView(
                  this.#currentFilters.cookingMethodValue,
                  'cooking-method'
                )
              } else {
                if (
                  !this.#currentFilters.cookingMethodValue &&
                  !this.#currentFilters.seafoodTypeValue
                ) {
                  this.updateView(
                    this.#currentFilters.seafoodTypeValue,
                    'seafood-type'
                  )
                } else {
                  this.clearFilters()
                }
              }
            })
          }
        }

        // filter facet click
        if (e.target.closest('fieldset label')) {
          if (e.target.closest('.filter-facet-pill')) return
          // go to next tick, otherwise we won't be able to get the current values
          setTimeout(() => {
            this.filterCards(e)
          })
        }

        // clear all filters
        if (e.target.closest('.clear-filters')) {
          this.clearFilters()
        }

        // toggle filter accordion
        if (e.target.closest('summary')) {
          this.querySelectorAll('details').forEach((details) => {
            if (
              details.querySelector('summary') !== e.target.closest('summary')
            ) {
              details.removeAttribute('open')
            }
          })
        }
      }

      toggleDrawer() {
        this.parentElement.classList.toggle('filter-drawer-open')
      }

      openDrawer() {
        this.parentElement.classList.add('filter-drawer-open')
      }

      closeDrawer() {
        this.parentElement.classList.remove('filter-drawer-open')
      }

      clearFilters() {
        this.resetHiddenCards()
        this.querySelectorAll('input[type="radio"]').forEach((input) => {
          input.checked = false
        })
        this.querySelector('.article-count').innerHTML =
          `${this.#articles.length} recipes`
        document.querySelector('.blog-articles').removeAttribute('style')
        this.#currentFilters.seafoodTypeResults = []
        this.#currentFilters.cookingMethodResults = []
        this.#currentFilters.occasionResults = []

        this.#currentFilters.seafoodTypeValue = null
        this.#currentFilters.cookingMethodValue = null
        this.#currentFilters.occasionValues = null
      }

      resetHiddenCards() {
        document.querySelectorAll('.article-card-wrapper').forEach((card) => {
          if (card.closest('.article.hidden'))
            card.closest('.article.hidden').classList.remove('hidden')
        })
      }

      filterCards(e) {
        const filter = e.target.closest('fieldset').dataset.filter
        const filterValue = e.target.closest('label').dataset.value
        const filterSetValues = Array.from(
          this.querySelectorAll('fieldset input')
        )
          .filter((input) => input.checked === true)
          .map((v) => {
            return {
              filter: v.parentElement.dataset.filter,
              filterValue: v.nextElementSibling.dataset.value
            }
          })

        this.resetHiddenCards()

        // console.debug({
        //   filter,
        //   filterValue,
        //   filterSetValues,
        //   articles: this.#articles,
        //   metafields: this.#metafields,
        //   currentFilters: this.#currentFilters
        // })

        this.updateView(filterValue, filter)
      }

      updateView(filterValue, filter) {
        let matchedIds = this.getMatchedIds(filterValue, filter)
        this.#currentMatches = matchedIds
        // hide all cards except the ones with id that match
        document.querySelectorAll('.article-card-wrapper').forEach((card) => {
          if (!matchedIds.includes(parseInt(card.dataset.articleId))) {
            card.closest('.article').classList.add('hidden')
          }
        })

        // update count
        this.#resultCount = matchedIds.length
        this.querySelector('.article-count').innerHTML =
          `${this.#resultCount} recipes`

        // bugfix top alignment issue when less than 4 cards shown
        if (this.#resultCount < 4) {
          document
            .querySelector('.blog-articles')
            .setAttribute('style', 'top: 0;')
        }

        document
          .querySelector('.blog-content-container')
          .setAttribute('data-results', this.#resultCount)

        document
          .querySelector('.blog-content-container')
          .setAttribute('data-last-filter-type', filter)
        document
          .querySelector('.blog-content-container')
          .setAttribute('data-last-filter-value', filterValue)

        this.resetPaginatorValues(matchedIds)
        this.displayPage()
      }

      getMatchedIds(filterValue, filter) {
        let matchedIds = []
        if (filter === 'seafood-type') {
          let titleMatch = new Set([...this.filterByTitle(filterValue, filter)])
          let tagsMatch = this.filterByTags(filterValue)
          tagsMatch.forEach((item) => {
            titleMatch.add(item)
          })
          matchedIds = [...titleMatch]
          if (filterValue !== this.#currentFilters.seafoodTypeValue) {
            this.#currentFilters.cookingMethodResults = []
            this.#currentFilters.occasionResults = []
            this.querySelectorAll(
              `details fieldset:not([data-filter="${filter}"]) input`
            ).forEach((input) => {
              input.checked = false
            })
          }
          this.#currentFilters.seafoodTypeValue = filterValue
          this.#currentFilters.seafoodTypeResults = matchedIds
        }

        if (filter === 'cooking-method') {
          matchedIds = this.filterByMetafield(filterValue, filter)
          let match = new Set([...matchedIds])
          let tagsMatch = this.filterByTags(filterValue)
          tagsMatch.forEach((item) => {
            match.add(item)
          })
          matchedIds = [...match]
          if (filterValue !== this.#currentFilters.cookingMethodValue) {
            this.#currentFilters.occasionResults = []
            this.querySelectorAll(`[data-filter="occasion"] input`).forEach(
              (input) => {
                input.checked = false
              }
            )
          }

          this.#currentFilters.cookingMethodValue = filterValue
          this.#currentFilters.cookingMethodResults = matchedIds
        }

        if (filter === 'occasion') {
          matchedIds = this.filterByMetafield(filterValue, filter)
          this.#currentFilters.occasionValues = filterValue
          this.#currentFilters.occasionResults = matchedIds
        }

        return matchedIds
      }

      getFilterKey(filter) {
        let key = 'seafood_type'
        switch (filter) {
          case 'cooking-method':
            key = 'cooking_method'
            break
          case 'occasion':
            key = 'recipe_occasion'
            break

          default:
            key = 'seafood_type'
            break
        }

        return key
      }

      filterByTitle(filterValue) {
        const matchedIds = []
        if (!filterValue.includes(',')) {
          this.#articles
            .filter((v) => v.title.toLowerCase().includes(filterValue))
            .map((x) => {
              matchedIds.push(x.id)
            })
          // TODO: go through it again for tag, metafields, the html body
        } else {
          this.#articles
            .filter((v) =>
              filterValue
                .split(',')
                .some((substring) => v.title.toLowerCase().includes(substring))
            )
            .map((x) => {
              matchedIds.push(x.id)
            })
        }

        return matchedIds
      }
      filterByTags(filterValue) {
        const matchedIds = []
        if (!filterValue.includes(',')) {
          this.#articles
            .filter((v) => v.tags.toLowerCase().includes(filterValue))
            .map((x) => {
              matchedIds.push(x.id)
            })
          // TODO: go through it again for tag, metafields, the html body
        } else {
          this.#articles
            .filter((v) =>
              filterValue
                .split(',')
                .some((substring) => v.tags.toLowerCase().includes(substring))
            )
            .map((x) => {
              matchedIds.push(x.id)
            })
        }

        return matchedIds
      }
      filterByMetafield(filterValue, filter) {
        const metafieldMatches = []
        const matchedIds = []
        let key = this.getFilterKey(filter)

        this.#metafields
          .filter((v) => v[key]?.toLowerCase() === filterValue)
          .map((x) => {
            metafieldMatches.push(x.article_id)
          })

        if (this.#currentFilters.seafoodTypeResults.length === 0) {
          return metafieldMatches
        } else {
          switch (filter) {
            case 'cooking-method':
              this.#currentFilters.seafoodTypeResults
                .filter((v) => metafieldMatches.includes(v))
                .map((x) => {
                  matchedIds.push(x)
                })

              return matchedIds

            case 'occasion':
              if (this.#currentFilters.seafoodTypeResults.length === 0) {
                return metafieldMatches
              } else {
                if (this.#currentFilters.cookingMethodResults.length === 0) {
                  this.#currentFilters.seafoodTypeResults
                    .filter((v) => metafieldMatches.includes(v))
                    .map((x) => {
                      matchedIds.push(x)
                    })

                  return matchedIds
                }
                this.#currentFilters.cookingMethodResults
                  .filter((v) => metafieldMatches.includes(v))
                  .map((x) => {
                    matchedIds.push(x)
                  })

                return matchedIds
              }

            case 'seafood-type':
              return metafieldMatches
            default:
              break
          }

          return metafieldMatches
        }
      }
    }
  )
}
if (!customElements.get('filter-icon')) {
  customElements.define(
    'filter-icon',
    class FilterIcon extends HTMLElement {
      connectedCallback() {
        if (this.querySelector('img').src.includes('.svg?v=')) {
          fetch(this.querySelector('img').src)
            .then((res) => res.text())
            .then((svg) => {
              this.innerHTML = svg
            })
        }
      }
    }
  )
}

document.querySelector('.no-results-message').addEventListener('click', (e) => {
  if (e.target.closest('strong')) {
    document.querySelector('filter-container').clearFilters()
  }
})
